import script from "./WebinarModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./WebinarModal.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__